// ============================================================================
// ELIGIBILITY CRITERIA ENDPOINTS — Phase E
// ============================================================================
// Backend: EligibilityCriteriaController -> /api/v1/EligibilityCriteria.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ELIGIBILITY_CRITERIA_BASE_PATH = '/EligibilityCriteria';

export const eligibilityCriteriaEndpoints = {
  list: () => buildEndpoint(ELIGIBILITY_CRITERIA_BASE_PATH),
  fields: () => buildEndpoint(`${ELIGIBILITY_CRITERIA_BASE_PATH}/fields`),
  byCaseType: (caseTypeCode: string, includeHistory = false) =>
    buildEndpoint(`${ELIGIBILITY_CRITERIA_BASE_PATH}/by-case-type?caseTypeCode=${encodeURIComponent(caseTypeCode)}&includeHistory=${includeHistory}`),
  getById: (id: ID) =>
    buildEndpointWithParams(`${ELIGIBILITY_CRITERIA_BASE_PATH}/:id`, { id }),
  save: () => buildEndpoint(ELIGIBILITY_CRITERIA_BASE_PATH),
  delete: (id: ID) =>
    buildEndpointWithParams(`${ELIGIBILITY_CRITERIA_BASE_PATH}/:id`, { id }),
  findEligible: (id: ID) =>
    buildEndpointWithParams(`${ELIGIBILITY_CRITERIA_BASE_PATH}/:id/find-eligible`, { id }),
} as const;

export default eligibilityCriteriaEndpoints;
